import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#44403C",
      stroke: "#44403C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.6",
      d: "M15 6.667a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M5 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M15 18.333a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#44403C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "m7.158 11.258 5.692 3.317M12.842 5.425 7.158 8.742"
    }, null, -1)
  ]))]))
}
export default { render: render }